import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from '@app/serviceWorker';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import { store } from '@app/store/store';
import { MsalProvider } from "@azure/msal-react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { TrackJS } from 'trackjs';
import { TeamsCheckAppWrapper } from "@app/TeamsCheckAppWrapper";
import { msalInstance, initializeMsalInstance } from '@shared/services/msalInstance';
import { googleClientId } from '@shared/services/EnvironmentVariables';
import { setStoreRef } from '@shared/services/storeRef';
import { AuthGatewayProvider } from '@shared/auth/AuthGatewayProvider';

if (import.meta.env.PROD) {
  TrackJS?.install({
    token: "c2bbd906babe4cb5871ba829f7f393b0"
  });
}

async function startApp() {
  setStoreRef(store);
  await initializeMsalInstance();

  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <Provider store={store}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <AuthGatewayProvider>
              <TeamsCheckAppWrapper />
            </AuthGatewayProvider>
          </MsalProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </Provider>
  );
}

startApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
